import { render, staticRenderFns } from "./PeopleAnalytics.vue?vue&type=template&id=627c4507&"
import script from "./PeopleAnalytics.vue?vue&type=script&lang=js&"
export * from "./PeopleAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports